import { render, staticRenderFns } from "./IntroductionWithPromo.vue?vue&type=template&id=472de198&scoped=true&"
import script from "./IntroductionWithPromo.vue?vue&type=script&lang=js&"
export * from "./IntroductionWithPromo.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionWithPromo.vue?vue&type=style&index=0&id=472de198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472de198",
  null
  
)

export default component.exports